import StartPageContainer from './StartPageContainer';

export default StartPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/StartPage/index.js